import { useState, useRef, useEffect } from 'react';
import { CheckboxCheckedIcon, CheckboxUncheckedIcon, DropdownArrowIcon } from '../../assets/icons/Icons';
import { getPriorityIcon } from '../Schedule/CurrentScheduleView';

const OrderDropdown = ({ label, orders, selectedOrderIds, setSelectedOrderIds }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const allOrderIds = orders.map(order => order.orderId);
    const isAllSelected = selectedOrderIds.length === allOrderIds.length;
    const isNoneSelected = selectedOrderIds.length === 0;

    const toggleDropdown = () => setOpen(prev => !prev);

    const handleOutsideClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    const toggleSelectAll = () => {
        setSelectedOrderIds(isAllSelected ? [] : allOrderIds);
    };

    const toggleOrder = (orderId) => {
        setSelectedOrderIds(prev =>
            prev.includes(orderId)
                ? prev.filter(id => id !== orderId)
                : [...prev, orderId]
        );
    };

    const displayLabel = orders.length === 0
        ? 'No Orders'
        : isAllSelected
            ? 'All Orders'
            : isNoneSelected
                ? 'None'
                : `${selectedOrderIds.length} order${selectedOrderIds.length > 1 ? 's' : ''}`;

    return (
        <div ref={dropdownRef} className='dropdown-container'>
            <div className='dropdown-label-field'>
                {
                    orders.length === 0 ?
                        <div className='dropdown-label-button'>
                            {displayLabel}
                        </div> :
                        <button className='dropdown-label-button'
                            onClick={toggleDropdown}>
                            {displayLabel}
                            <span className={`dropdown-arrow-icon ${open ? 'open' : ''}`}>
                                <DropdownArrowIcon />
                            </span>
                        </button>
                }
            </div>

            {open && (
                <div
                    className='dropdown-panel'
                >
                    <label className='dropdown-label' onClick={toggleSelectAll}>
                        {isAllSelected ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
                        {' '}
                        All Orders
                    </label>

                    {orders.map(order => (
                        <label key={order.orderId} className='dropdown-label' onClick={() => toggleOrder(order.orderId)}>
                            {selectedOrderIds.includes(order.orderId) ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
                            <span>
                                <img className="" src={getPriorityIcon(order?.spec?.attributes?.priorityLane)} alt="" />
                            </span>
                            {order.spec?.name || ''}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OrderDropdown;
